// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__vNe0_","tryAgain":"styles_tryAgain__eSfZc"};